import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const SaveIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 17"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M17 10.1493L17 14.209C17 15.33 16.0912 16.2388 14.9701 16.2388L2.79104 16.2388C1.66999 16.2388 0.761192 15.33 0.761192 14.209L0.761193 10.1493M8.8806 10.3338L4.45183 5.90502M8.8806 10.3338L13.3094 5.90502M8.8806 10.3338L8.88059 2.58087e-07" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
  </Svg>
);

SaveIcon.displayName = 'SaveIcon';
